import cs from 'classnames';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { ButtonProps } from 'react-bootstrap/Button';
import { GoogleLogo } from './GoogleLogo';
import styles from './GoogleSignInButton.module.scss';

export function GoogleSignInButton({
  className, ...props
} : ButtonProps) {
  return (
    <div className={styles.container}>
      <Button
        className={cs(styles.submitButton, className)}
        variant="default"
        type="submit"
        {...props}
      >
        <Row className={styles.content}>
          <Col xs="auto" className={styles.logoWrapper}>
            <GoogleLogo />
          </Col>
          <Col>
            Sign in with Google
          </Col>
        </Row>
      </Button>
    </div>
  );
}
